import { c as _c } from "react/compiler-runtime";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import styles from "./ITNCoverage.module.scss";
import { useState } from "react";
import { EffektSliderGeneric } from "../../../shared/components/EffektSliderGeneric/EffektSliderGeneric";
import { PortableText } from "@portabletext/react";
import { ITNCoverageGraph } from "./ITNCoverageGraph";
export const ITNCoverage: React.FC<{
  title: string;
  subtitle: string;
  images: SanityImageObject[];
  range: [number, number];
  mapExplenation?: string;
  graphExplenation?: string;
  caption?: any[];
}> = t0 => {
  const $ = _c(53);
  const {
    title,
    subtitle,
    images,
    range,
    mapExplenation,
    graphExplenation,
    caption
  } = t0;
  const [start, end] = range;
  const [sliderValue, setSliderValue] = useState(start + 2);
  const [showing, setShowing] = useState("map");
  if (images.length !== end - start + 1) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div>Missing images for ITN coverage</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const current = Math.floor((sliderValue - start) % images.length);
  const next = current + 1;
  const currentOpacity = 1 - sliderValue % 1;
  let t1;
  if ($[1] !== title) {
    t1 = <p className="inngress">{title}</p>;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== subtitle) {
    t2 = <span className={styles.subtitle}>{subtitle}</span>;
    $[3] = subtitle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = val => setSliderValue(val);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== end || $[7] !== sliderValue || $[8] !== start) {
    t4 = <EffektSliderGeneric min={start} max={end} value={sliderValue} onChange={t3} />;
    $[6] = end;
    $[7] = sliderValue;
    $[8] = start;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = showing === "map" ? 1 : 0;
  const t6 = showing === "map" ? "translateX(0)" : "translateX(-1rem)";
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = {
      opacity: t5,
      transform: t6
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== current || $[14] !== currentOpacity || $[15] !== images || $[16] !== next) {
    let t9;
    if ($[18] !== current || $[19] !== currentOpacity || $[20] !== next) {
      t9 = (image, i) => <div className={styles.image} key={i} style={{
        opacity: i === current ? currentOpacity : i === next ? 1 : 0,
        zIndex: i === current ? 1 : 0
      }}><ResponsiveImage image={image} key={i} layout="fill" /></div>;
      $[18] = current;
      $[19] = currentOpacity;
      $[20] = next;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t8 = images.map(t9);
    $[13] = current;
    $[14] = currentOpacity;
    $[15] = images;
    $[16] = next;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[22] !== mapExplenation) {
    t9 = <i className={styles.explenation}>{mapExplenation}</i>;
    $[22] = mapExplenation;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <div className={styles.imageWrapper} style={t7}>{t8}{t9}</div>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const t11 = showing === "graph" ? 1 : 0;
  const t12 = showing === "graph" ? "translateX(0)" : "translateX(1rem)";
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = {
      opacity: t11,
      transform: t12
    };
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== sliderValue) {
    t14 = <ITNCoverageGraph year={sliderValue} />;
    $[31] = sliderValue;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== graphExplenation) {
    t15 = <i className={styles.explenation}>{graphExplenation}</i>;
    $[33] = graphExplenation;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
    t16 = <div className={styles.graphWrapper} style={t13}>{t14}{t15}</div>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== showing) {
    t17 = <div className={styles.buttons}>{showing === "graph" ? <button onClick={() => setShowing("map")}>← Se kart</button> : <button onClick={() => setShowing("graph")}>Se graf →</button>}</div>;
    $[39] = showing;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t10 || $[42] !== t16 || $[43] !== t17) {
    t18 = <div className={styles.content}>{t10}{t16}{t17}</div>;
    $[41] = t10;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== caption) {
    t19 = <span className="caption"><PortableText value={caption} /></span>;
    $[45] = caption;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t1 || $[48] !== t18 || $[49] !== t19 || $[50] !== t2 || $[51] !== t4) {
    t20 = <div className={styles.wrapper}>{t1}{t2}{t4}{t18}{t19}</div>;
    $[47] = t1;
    $[48] = t18;
    $[49] = t19;
    $[50] = t2;
    $[51] = t4;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
};